import { Injectable } from '@angular/core';
import { CurrentUser } from './current-user';
import { TranslateService } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import moment from 'moment';
import { ConfigProvider } from "../../config-provider.service";
import { UtilsProvider } from "./utils-provider.service";
import { DateAdapter } from '@angular/material/core';

export interface Lang {
	id: number;
    name: string;
    shortName: string;
    code: string;
    dateLocale: string;
    angularLocale: any;
}

@Injectable({
    providedIn: 'root'
})
export class LangsProvider {
    constructor(
        private configProvider: ConfigProvider,
        private utilsProvider: UtilsProvider,
        private currentUser: CurrentUser,
        private translateService: TranslateService,
        private dateAdapter: DateAdapter<any>
    ) { }

    public selectLang(langConfig: any): void {
        this.translateService.use(langConfig.code);
        registerLocaleData(langConfig.angularLocale);
        moment.locale(langConfig.dateLocale);
        this.dateAdapter.setLocale(langConfig.dateLocale);
    }

    public getBestLangConfig(): any {
        if (this.currentUser.isLoggedIn()) {
            for (const langConfig of this.configProvider.availableLangs) {
                if (this.currentUser.user && langConfig.id === this.currentUser.user.langId) {
                    return langConfig;
                }
            }
        }

        let browserLangCode = this.translateService.getBrowserCultureLang();
        if (browserLangCode === undefined) {
            browserLangCode = this.translateService.getBrowserLang();
        }

        for (const langConfig of this.configProvider.availableLangs) {
            if (langConfig.code === browserLangCode) {
                return langConfig;
            }
        }

        return this.configProvider.defaultLang;
    }

    public getBestLangCode(): string {
        return this.getBestLangConfig().code;
    }

    public getBestLangId(): number {
        return this.getBestLangConfig().id;
    }

    public getLangs(): any[] {
        const langs: any[] = [];
        for (let i = 0; i < this.configProvider.availableLangs.length; i++) {
            langs.push(this.configProvider.availableLangs[i]);
        }

        return langs;
    }

    public getLangCodes(): string[] {
        const langs: string[] = [];
        for (let i = 0; i < this.configProvider.availableLangs.length; i++) {
            langs.push(this.configProvider.availableLangs[i].code);
        }

        return langs;
    }

    public getLangIds(): number[] {
        const langs: number[] = [];
        for (let i = 0; i < this.configProvider.availableLangs.length; i++) {
            langs.push(this.configProvider.availableLangs[i].id);
        }

        return langs;
    }
}
